module.exports = __webpack_public_path__ + "static/media/desarrollo1.0b2fc118.png";